<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-header pb-0 d-flex align-items-center justify-content-between">
            <h6 class="mb-0">
              <i class="fas fa-history me-2 text-warning"></i>
              Cierres de caja
            </h6>
            <button class="btn btn-sm btn-outline-secondary" @click="loadHistory" :disabled="loading">
              <i class="fas fa-sync-alt" :class="{ 'fa-spin': loading }"></i>
            </button>
          </div>

          <div class="card-body px-0 pt-0 pb-2">
            <div v-if="loading" class="text-center py-5">
              <i class="fas fa-spinner fa-spin fa-2x text-warning"></i>
            </div>

            <div v-else-if="history.length === 0" class="text-center text-muted py-5">
              <i class="fas fa-inbox fa-2x mb-2 d-block"></i>
              No hay registros de caja todavía.
            </div>

            <div v-else class="table-responsive">
              <table class="table align-items-center mb-0">
                <thead>
                  <tr>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">#</th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Estado</th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Apertura</th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Monto apertura</th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Cierre</th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Monto cierre</th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Notas</th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="session in history" :key="session.id">
                    <td class="ps-4">
                      <span class="text-xs font-weight-bold">{{ session.id }}</span>
                    </td>
                    <td>
                      <span class="badge badge-sm" :class="session.status === 'open' ? 'bg-success' : 'bg-secondary'">
                        {{ session.status === 'open' ? 'Abierta' : 'Cerrada' }}
                      </span>
                    </td>
                    <td>
                      <span class="text-xs">{{ formatDate(session.opened_at) }}</span>
                    </td>
                    <td>
                      <span class="text-xs font-weight-bold">{{ formatMoney(session.opening_amount) }}</span>
                    </td>
                    <td>
                      <span class="text-xs">{{ session.closed_at ? formatDate(session.closed_at) : '—' }}</span>
                    </td>
                    <td>
                      <span class="text-xs font-weight-bold">{{ session.closing_amount != null ? formatMoney(session.closing_amount) : '—' }}</span>
                    </td>
                    <td>
                      <span class="text-xs text-muted">{{ session.closing_notes || session.opening_notes || '—' }}</span>
                    </td>
                    <td>
                      <button
                        class="btn btn-sm btn-outline-warning px-2 py-1"
                        @click="openTicket(session.id)"
                        title="Ver / Imprimir tirilla"
                      >
                        <i class="fas fa-print"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'CashRegister',
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    ...mapGetters('cashRegister', ['history']),
  },
  methods: {
    formatMoney(value) {
      return (Number(value) || 0).toLocaleString('es-CO', { minimumFractionDigits: 0 });
    },
    formatDate(value) {
      if (!value) return '—';
      return new Date(value).toLocaleString('es-CO', {
        dateStyle: 'short',
        timeStyle: 'short',
      });
    },
    openTicket(sessionId) {
      const route = this.$router.resolve({
        name: 'CashRegisterTicket',
        query: { id: String(sessionId) },
      });
      window.open(route.href, '_blank');
    },
    async loadHistory() {
      this.loading = true;
      await this.$store.dispatch('cashRegister/fetchHistory');
      this.loading = false;
    },
  },
  async mounted() {
    await this.loadHistory();
  },
};
</script>
